module.exports = __webpack_public_path__ + "img/home-all-1.738e9df7.png";